var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalfLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_20124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00128 7.984L8.12463 9.17255L7.65038 6.78585L9.43693 5.1337L7.02048 4.84717L6.00128 2.63751V7.984ZM6.00128 9.13L2.47455 11.1041L3.26222 7.13995L0.294922 4.3959L4.30844 3.92003L6.00128 0.25L7.69408 3.92003L11.7076 4.3959L8.74033 7.13995L9.52798 11.1041L6.00128 9.13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_20124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalfLine);
export default __webpack_public_path__ + "static/media/star-half-line.c370b47d51153d63b3d34c09147a90ac.svg";
export { ForwardRef as ReactComponent };